import React from 'react';
import { Input } from '@folksam/ui-next/components';
import { useField } from 'react-final-form';
import { required, combineValidators, validOmbudsnr } from '../../../services/validators.service';
import { useTranslation } from 'react-i18next';
import FormField from '../../FormField';

// /^[0-9]{1,7}$/
function Ombudsnummer({ label, ...props }) {
    const { t } = useTranslation();

    // Define validators to match old angular validators, with matching error text from commondata translations
    const validators = combineValidators([
        required(t('empty_mandatory_error')),
        validOmbudsnr(t('ombudsnummer_validation_txt'))
    ]);

    const { input, meta } = useField(props.name, { validate: validators });

    return (
        <FormField
            label={label}
            meta={meta}
            id={props.fieldId}
            component={Input}
            inputProps={{
                maxlength: '13',
                className: `sessioncamexclude`,
                ...props,
                id: props.fieldId,
                ...input,
                postfix: props.infoButton
            }}
        />
    );
}
export default Ombudsnummer;
